import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';
import { Button } from './ui/button';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setVisible(false);
    // Enable analytics
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'granted', ad_storage: 'granted' });
    }
    if (window.fbq) {
      window.fbq('consent', 'grant');
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setVisible(false);
    // Disable analytics
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'denied', ad_storage: 'denied' });
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[70] p-4 animate-slideUp" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-slate-900 text-white rounded-2xl shadow-2xl border border-slate-700 p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex flex-shrink-0 w-10 h-10 bg-emerald-500/20 rounded-full items-center justify-center mt-0.5">
            <Shield className="w-5 h-5 text-emerald-400" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-base mb-1">We value your privacy</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              We use cookies and similar technologies to improve your experience, analyze traffic, and personalize content. 
              By clicking "Accept", you consent to our use of cookies as described in our{' '}
              <a href="/privacy" className="text-emerald-400 underline hover:text-emerald-300">Privacy Policy</a>.
            </p>
          </div>
          <button onClick={handleDecline} className="text-gray-400 hover:text-white flex-shrink-0 sm:hidden">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex items-center justify-end gap-3 mt-4">
          <Button
            onClick={handleDecline}
            variant="ghost"
            data-testid="cookie-decline-btn"
            className="text-gray-300 hover:text-white hover:bg-slate-700 px-6"
          >
            Decline
          </Button>
          <Button
            onClick={handleAccept}
            data-testid="cookie-accept-btn"
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 rounded-full"
          >
            Accept Cookies
          </Button>
        </div>
      </div>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slideUp { animation: slideUp 0.4s ease-out; }
      `}</style>
    </div>
  );
};
